<template>

<div class="containerClass">

    <div class="titleClass">
        Scan QR code to get the official APP 😎
    </div>

    <img :src="qrcodeImage" :style="styleQrCode">

</div>

</template>

<script>

//url
import {ImageUrl} from "@/UrlService.js"

export default{

    data: function() {
        return({
            qrcodeImage: ImageUrl() + "?filename=" + this.$route.query["qrcode"],
            styleQrCode: {width: "230px", marginTop: "20px"} 
        })
    }
}

</script>

<style scoped>
.containerClass{
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
}

.titleClass{
    font-size: larger;
}

</style>